import React, { useState } from 'react';
import axios from 'axios';
import { URL as URLBase, getAuthorizationHeader } from '../../constans/constants'
import { Modal, Row, Col, Button } from 'react-bootstrap';
import xCircle from '../../styles/icons/x-circle.svg'


class SafeRedirectManager {
  constructor() {
    // Dominios permitidos
    this.allowedDomains = [
      URLBase,
    ];
  }

  registerAlertMethod(method) {
    this.showBlockedRedirectAlert = method;
  }

  // Método para cargar dominios desde backend
  async fetchAllowedDomains() {
    try {
      // Endpoint configurable para obtener dominios permitidos
      await axios.get(URLBase + 'seguridad/dominios/get', getAuthorizationHeader())
        .then(response => {
          if (!response.data.error) {
            this.allowedDomains = [
              ...this.allowedDomains,
              ...response.data.datos
            ]
            return true;
          } else {
            console.error('Respuesta de dominios inválida');
            return false;
          }
        });
    } catch (error) {
      console.error('Error cargando dominios:', error);
      return false;
    }
  }

  // Validaciones de seguridad adicionales
  performExtendedSecurityChecks(parsedUrl) {
    const checks = [
      // Prevenir credenciales en la URL
      this.preventCredentialsInUrl(parsedUrl),

      // Bloquear redireccionamientos anidados
      this.preventNestedRedirects(parsedUrl),

      // Validar caracteres en la URL
      this.validateUrlCharacters(parsedUrl)
    ];

    // Todas las verificaciones deben pasar
    return checks.every(check => check);
  }

  // Verificar si el dominio está permitido
  isAllowedDomain(url) {
    try {
      const parsedUrl = new URL(url);

      // Verificar dominio
      const isValidDomain = this.allowedDomains.some(allowedDomain =>
        parsedUrl.hostname.includes(allowedDomain)
      );

      // Si el dominio no está permitido, retornar falso
      if (!isValidDomain) {
        console.warn('Dominio no permitido:', parsedUrl.hostname);
        return false;
      }

      // Realizar validaciones de seguridad adicionales
      return this.performExtendedSecurityChecks(parsedUrl);
    } catch (error) {
      console.warn('URL inválida:', url);
      return false;
    }
  }

  // Prevenir credenciales en la URL
  preventCredentialsInUrl(parsedUrl) {
    const hasCredentials = parsedUrl.username || parsedUrl.password;
    if (hasCredentials) {
      console.warn('URL contiene credenciales');
      return false;
    }
    return true;
  }

  // Prevenir redireccionamientos anidados
  preventNestedRedirects(parsedUrl) {
    const redirectMarkers = [
      'redirect=',
      'next=',
      'url=',
      'continue='
    ];

    const hasNestedRedirect = redirectMarkers.some(marker =>
      parsedUrl.href.includes(marker)
    );

    if (hasNestedRedirect) {
      console.warn('URL contiene marcadores de redirección anidada');
      return false;
    }
    return true;
  }

  // Validar caracteres en la URL
  validateUrlCharacters(parsedUrl) {
    const maliciousPatterns = [
      /\s/,        // Espacios
      /[\<\>]/,    // Paréntesis angulares
      /javascript:/i,  // Protocolo JavaScript
      /data:/i     // Protocolo de datos
    ];

    const hasInvalidCharacters = maliciousPatterns.some(pattern =>
      pattern.test(parsedUrl.href)
    );

    if (hasInvalidCharacters) {
      console.warn('URL contiene caracteres no permitidos');
      return false;
    }
    return true;
  }

  // Método de redirección segura
  safeRedirect(url) {
    // Validar dominio y seguridad
    if (this.isAllowedDomain(url)) {
      window.location.href = url;
      return true;
    } else {
      console.error('Redirección bloqueada por razones de seguridad');

      if (this.showBlockedRedirectAlert) {
        this.showBlockedRedirectAlert(url);
      }

      return false;
    }
  }
}

export const BlockedRedirectAlert = () => {
  const [show, setShow] = useState(false);
  const [blockedUrl, setBlockedUrl] = useState('');

  // Método para mostrar la alerta
  const handleShowAlert = (url) => {
    setBlockedUrl(url);
    setShow(true);
  };

  // Método para ocultar la alerta
  const handleClose = () => {
    setShow(false);
  };

  // Registrar el método de mostrar alerta en la instancia del gestor
  React.useEffect(() => {
    safeRedirectManager.registerAlertMethod(handleShowAlert);
  }, []);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
    >
      <Modal.Body>
        <div>
          <Row className="justify-content-center">
            <Col className="text-center text-md-right">
              <img src={xCircle} style={{ margin: '40px' }}></img>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col className="text-center text-md-right">
              <p><strong>Redireccion bloqueada por motivos de seguridad</strong></p>
            </Col>
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          Aceptar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// Crear instancia global
const safeRedirectManager = new SafeRedirectManager();

// Inicializar carga de dominios al inicio
safeRedirectManager.fetchAllowedDomains();

export default safeRedirectManager;